<mat-form-field
    appearance="outline"
    class="entity-table-date-field"
    subscriptSizing="dynamic"
    [class.entity-table-date-field--detail]="context() === EntityTableDateCellContext.DETAIL"
    [class.entity-table-date-field--edited]="edited()">
    @if (context() === EntityTableDateCellContext.DETAIL) {
        @for (error of errorMessages(); track error) {
            <mat-error class="text-xs">{{ error | transloco }}</mat-error>
        }
    }

    <input
        matInput
        [formControl]="control"
        [matDatepicker]="picker"
        [placeholder]="dateFormatPlaceholder"
        (blur)="handleBlur()"
        (dateChange)="onDateChange($event)" />

    <mat-datepicker-toggle
        matIconSuffix
        [for]="picker">
        <mat-icon matDatepickerToggleIcon>schedule</mat-icon>
    </mat-datepicker-toggle>

    <mat-datepicker #picker>
        <mat-datepicker-actions>
            <div class="flex items-center gap-2 p-2 bg-background rounded border border-background text-sm">
                <span class="font-medium text-gray-700">{{ 'hour' | transloco }}</span>
                <input
                    class="px-2 py-1 border border-solid border-background rounded focus:outline-none focus:border-blue-500 text-base"
                    type="time"
                    [formControl]="timeControl"
                    (change)="onTimeInputChange()" />
            </div>
            <app-button
                matDatepickerApply
                [label]="'validate' | transloco" />
        </mat-datepicker-actions>
    </mat-datepicker>

    @if (errorMessages().length && context() === EntityTableDateCellContext.TABLE) {
        @for (error of errorMessages(); track error) {
            <mat-error class="text-xs">{{ error | transloco }}</mat-error>
        }
    }
</mat-form-field>
